var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{staticClass:"is-bold"},[_vm._v(_vm._s(_vm.$t('auth.logging_out')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }